<template>
  <div class="RadialChart">
    <apexchart
      type=radialBar
      height=350
      :options="chartOptions"
      :series="chartSeries"
      :key="chartKey"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'RadialChart',

  /**
   * Elementos que recibe el componente para renderizar
   */
  props: {
    /** Objeto a renderizar */
    indSynt: {
      type: Object,
      required: true
    }
  },

  components: {
    apexchart: VueApexCharts
  },

  created () {
    this.chartSeries.push(this.indSynt.res),
    this.chartOptions.labels.push(this.indSynt.ind),
    this.chartOptions.colors.push(this.color[this.indSynt.cat])
    this.chartKey += 1

  },

  data: function() {
    return {
      chartOptions: {
        chart: {
          offsetY: -20
        },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#e7e7e7",
              strokeWidth: '97%',
              margin: 5, // margin is in pixels
              shadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: '#999',
                opacity: 1,
                blur: 2
              }
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                offsetY: -2,
                fontSize: '22px',
                formatter: function (val) {
                  return val
                }
              }
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            shadeIntensity: 0.4,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 53, 91]
          },
        },
        colors: [],
        labels: [],
        legend: {
          show: true,
          floating: true,
          fontSize: '16px',
          position: 'bottom'
        }
      },
      chartSeries: [],
      chartKey: 0,

      color: {
        1:'#FF5252',
        2:'#E86205',
        3:'#FFC107',
        4:'#D4E805',
        5:'#4CAF50'
      }
    }
  }
}
</script>
